import { render } from "./TxtIcon.vue?vue&type=template&id=e08164b8"
const script = {}
script.render = render

export default script